import { ACLS } from '@config/constants/acls';
import { useAuthorization } from '@lib/authorization';
import { ActionIcon, Flex, Tooltip } from '@mantine/core';
import {
	IconEye,
	IconHexagon,
	IconTrash,
} from '@tabler/icons-react';
import { MouseEventHandler } from 'react';
import { useTranslation } from 'react-i18next';

export const CellProductionActions = (props: {
	onShow: MouseEventHandler<HTMLButtonElement>;
	onDelete?: MouseEventHandler<HTMLButtonElement>;
	isDeleted?: boolean;
	onVerify?: MouseEventHandler<HTMLButtonElement>;
	isVerified?: boolean;
	isMinted?: boolean;
}) => {
	const { t } = useTranslation();
	const {
		onShow,
		onDelete,
		isDeleted,
		onVerify,
		isVerified,
		isMinted,
	} = props;

	const { checkAcls } = useAuthorization();
	return (
		<Flex gap="10px" justify={'flex-end'}>
			{checkAcls([ACLS.MINT_HISTORIES.CREATE]) && (
				<Tooltip
					label={
						isMinted
							? t('productions.mint')
							: isVerified
								? t('productions.alreadyMinted')
								: t('productions.verifyBeforeMinting')
					}
				>
					<ActionIcon
						disabled={!isMinted}
						h={'30px'}
						w={'30px'}
						variant="filled"
						radius={'xl'}
						color={'#E8F4FF'}
						onClick={onVerify}
					>
						<IconHexagon
							color={isMinted ? '#617EEF' : '#b9c1e4'}
							size="16px"
						/>
					</ActionIcon>
				</Tooltip>
			)}
			{checkAcls([ACLS.PRODUCTIONS.READ]) && (
				<ActionIcon
					h={'30px'}
					w={'30px'}
					variant="filled"
					radius={'xl'}
					color={'#DDF9ED'}
					onClick={onShow}
				>
					<IconEye
						color="#2C8C5E"
						size="18px"
						stroke={1.5}
					/>
				</ActionIcon>
			)}

			{checkAcls([ACLS.PRODUCTIONS.DELETE]) && (
				<ActionIcon
					disabled={!isDeleted}
					h={'30px'}
					w={'30px'}
					variant="filled"
					radius={'xl'}
					color="rgba(254, 229, 235, 0.60)"
					onClick={onDelete}
				>
					<IconTrash
						color={isDeleted ? '#FF381C' : '#e5c5c1'}
						size="18px"
						stroke={1.5}
					/>
				</ActionIcon>
			)}
		</Flex>
	);
};
